import api from "../../lib/api";
import { toast } from "react-toastify";
import queryString from "query-string";
import { userProfile } from "./accountActions";
import { mapPropertyResponse } from "../../utils";

const apiRoute = `/api/agent/`;

export const fetchProperties =
  (values = {}) =>
  (dispatch, getState) => {
    const value = { ...values };
    if (value.priceFrom === "") {
      value.priceFrom = 0;
    }
    let url = apiRoute;
    const state = getState();
    if (values.sort) {
      const url = `/new/api/v1/properties?page=1&limit=24&${
        values.sortBy || "sortPrice"
      }=${values.sort}`;
      const savedUrl = `/new/api/v1/properties?${
        values.sortBy || "sortPrice"
      }=${values.sort}&${queryString.stringify(state.property.fetchedParams)}&`;
      delete values.sort;
      delete values.page;
      return api
        .get(url, {
          params: state.property.fetchedParams,
        })
        .then((res) => {
          const mappedData =
            res.data.data?.map(mapPropertyResponse) || res.data.data;
          dispatch({
            type: "FETCH_PROPERTIES",
            payload: mappedData,
            totalCount: res.data.totalCount,
            fetchUrl: savedUrl,
            lastFetched: savedUrl,
            fetchedParams: values,
          });
        })
        .catch((err) => {
          throw err;
        });
    }
    const filters = state.staticValues.filters;
    const page = value.page || 1;
    value.page = undefined;
    if (value.category) {
      url += `properties/types/${
        filters[value.category].name
      }?page=${page}&limit=24`;
      return api
        .get(url, {
          params: value,
        })
        .then((res) => {
          const mappedData =
            res.data.data?.map(mapPropertyResponse) || res.data.data;
          dispatch({
            type: "FETCH_PROPERTIES",
            payload: mappedData,
            totalCount: res.data.totalCount,
            fetchUrl: url,
            lastFetched: `${apiRoute}properties/types/${
              filters[value.category].name
            }?`,
            fetchedParams: values,
          });
        })
        .catch((err) => {
          throw err;
        });
    } else {
      const url = `${apiRoute}properties?page=${page}&limit=24`;
      return api
        .get(url, {
          params: value,
        })
        .then((res) => {
          const mappedData =
            res.data.data?.map(mapPropertyResponse) || res.data.data;
          dispatch({
            type: "FETCH_PROPERTIES",
            payload: mappedData,
            totalCount: res.data.totalCount,
            fetchUrl: url,
            lastFetched: `${apiRoute}properties?`,
            fetchedParams: values,
          });
        })
        .catch((err) => {
          throw err;
        });
    }
  };

export const fetchPropertyById = (id, admin) => (dispatch) => {
  let url = `${apiRoute}properties/code/${id}`;
  if (admin) {
    url += `?id=${admin}`;
  }

  return api
    .get(url)
    .then((res) => {
      if (res) {
        dispatch({
          type: "FETCH_PROPERTY",
          payload: mapPropertyResponse(res.data.data),
          recommendations: res.data.recommendations,
          differences: res.data.differences || [],
          differencesMapped: res.data.differencesMapped,
          similar: res.data.similar,
        });
      }
      return res;
    })
    .catch((err) => {
      if (id && err) {
        toast.error("Nekretnina Ne Postoji");
      }
      // throw err
    });
};

export const fetchPropertyByRealId = (id, user, diff) => (dispatch) => {
  return api
    .get(
      `${apiRoute}properties/id/${id}${user && diff ? "?differences=true" : ""}`
    )
    .then((res) => {
      dispatch({
        type: "FETCH_PROPERTY",
        payload: mapPropertyResponse(res.data.data),
        recommendations: res.data.recommendations
          ? res.data.recommendations
          : [],
        differences: res.data.differences || [],
        differencesMapped: res.data.differencesMapped,
        tasks: res.data.data.tasks || [],
      });
      return res;
    })
    .catch((err) => {
      toast.error("Nekretnina Ne Postoji");
      throw err;
    });
};

export const fetchPropertiesByAgentId = (id, query) => (dispatch) => {
  return api
    .get(`/api/agent/properties/${id}`, { params: { ...query } })
    .then((res) => {
      const mappedData =
        res.data.data?.map(mapPropertyResponse) || res.data.data;
      dispatch({
        type: "FETCH_PROPERTIES_BY_AGENT",
        payload: mappedData,
        tasksTotalCount: res.data.tasks_total_count,
        pagination: {
          currentPage: res.data.meta?.current_page || 1,
          lastPage: res.data.meta?.last_page || 1,
          perPage: res.data.meta?.per_page || 20,
          total: res.data.meta?.total || 0,
          links: res.data.links || {},
        },
      });
      return res;
    })
    .catch((err) => {
      toast.error("Greška");
      dispatch(userProfile());
      throw err;
    });
};

export const addPropertyAgent = (values) => () => {
  return api
    .post(`${apiRoute}properties/add`, {
      ...values,
    })
    .then((res) => {
      toast.success(res.data?.message || "Uspešno dodata nekretnina");
    })
    .catch((err) => {
      const errorMessage =
        err.response?.data?.message || "Greška pri dodavanju nekretnine";
      if (err.response?.status === 400) {
        toast.error(errorMessage);
      } else {
        toast.error(errorMessage);
      }
      throw err;
    });
};

export const editPropertyAgent = (values, id) => (dispatch) => {
  const val = { ...values };
  if (val["description"] && typeof val["description"] !== "object") {
    val["description"].description = val["description"];
  }
  if (val["descriptionEn"] || val["descriptionEn"] === "") {
    val["description"].descriptionEn = val["descriptionEn"];
    delete val["descriptionEn"];
  }
  if (val["descriptionRu"] || val["descriptionRu"] === "") {
    val["description"].descriptionRu = val["descriptionRu"];
    delete val["descriptionRu"];
  }
  return api
    .put(`${apiRoute}properties/${id}`, {
      ...val,
    })
    .then((res) => {
      dispatch({
        type: "EDIT_PROP",
        payload: res.data.data,
      });
      toast.success("Uspešno izmenjena");
      return res;
    })
    .catch((err) => {
      toast.error("Greška");
      throw err;
    });
};

export const getAgenciesRecommendationsAgent = () => (dispatch) => {
  return api
    .get("/api/agent/recommended/manager")
    .then((res) => {
      dispatch({
        type: "FETCH_AGENCY_PROPERTIES",
        payload: res.data,
        totalCount: res.data.totalCount,
      });
    })
    .catch((err) => {
      throw err;
    });
};

export const addAgencyRecommendation = (id) => (dispatch) => {
  return api
    .post(`/api/agent/recommended/${id}`)
    .then((res) => {
      dispatch({
        type: "ADD_AGENCY_PROPERTIES",
        payload: res.data.data,
        totalCount: res.data.totalCount,
      });
      return dispatch(getAgenciesRecommendationsAgent());
    })
    .catch((err) => {
      throw err;
    });
};

export const deleteAgencyRecommendation = (id) => (dispatch) => {
  return api
    .delete(`/api/agent/recommended/${id}`)
    .then((res) => {
      dispatch({
        type: "DELETE_AGENCY_PROPERTY",
        payload: res.data.data,
        totalCount: res.data.totalCount,
      });
      return dispatch(getAgenciesRecommendationsAgent());
    })
    .catch((err) => {
      throw err;
    });
};

export const checkPropertyCodeAvailability = (code) => (dispatch) => {
  return api
    .get(`/api/agent/properties/isAvailable/${code}`)
    .then((res) => {
      dispatch({
        type: "FETCH_PROPERTY_CODE_AVAILABILITY",
        payload: res.data,
      });
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const addTaskAgent = (id) => () => {
  return api
    .put(`/api/agent/tasks/action/${id}`)
    .then(() => {
      toast.success("Zadatak obavljen!");
    })
    .catch(() => {
      toast.error("Zadatak nije obavljen usled greške");
    });
};
